import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';
import type { SharedVacation } from './shared-vacation';
import { convertToDateTimeString } from './convert-to-date-time-string';

/**
 * Foreløpig er denne listen kun et eller null element. Hvordan dele med flere har noen uavklarte forhold
 */
export const sharedVacations = createSelector(getOrganization, (organization): SharedVacation[] => {
  if (organization === undefined) return [];
  if (organization.vacationSummaryShared && organization.vacationSummaryRecipient) {
    return [
      {
        email: organization.vacationSummaryRecipient,
        time: convertToDateTimeString(organization.vacationSummaryShared),
      },
    ];
  }
  return [];
});
